// extracted by mini-css-extract-plugin
export default {"s1":"RedStuff_s1__juH6R","line":"RedStuff_line__mRbRd","s2":"RedStuff_s2__EIQD2","s3":"RedStuff_s3__Q4lW0","s4":"RedStuff_s4__SUvrk"};